import script from "./UploadContractPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadContractPop.vue?vue&type=script&setup=true&lang=ts"

import "./UploadContractPop.vue?vue&type=style&index=0&id=ba0a931a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba0a931a"]])

export default __exports__